/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ role: NonNullable<unknown> }} Perks_Carry_DeletedInputs */



/**
* | output |
* | --- |
* | "@{role} no longer exists in Discord." |
*
* @param {Perks_Carry_DeletedInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const perks_carry_deleted = /** @type {((inputs: Perks_Carry_DeletedInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Perks_Carry_DeletedInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Роли @${i?.role} больше нет в Discord.`)
	return /** @type {LocalizedString} */ (`@${i?.role} no longer exists in Discord.`)
});